"use client";

import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import format from "date-fns/format"; // GLOBAL CUSTOM COMPONENTS
import { H6, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box"; // CUSTOM UTILS LIBRARY FUNCTION
import { formatMoney, toAssetImages } from "src/lib/utils";
import { Product } from "src/lib/fetcher/client";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import Link from "next/link";
import { useSalifyComponentContext } from "src/lib/components/salify-component/default";

// ==============================================================
const OrderedProducts = ({ order }: any) => {
  const context = useSalifyComponentContext();
  const placedAt = order?.purchaseDate ?? order?.createdAt;

  return (
    <Card
      sx={{
        p: 0,
        mb: "30px",
      }}
    >
      <FlexBetween px={3} py={2} flexWrap="wrap" bgcolor="grey.200">
        <SalifyFallback.Label
          path="Order ID:"
          default="Mã đơn hàng"
          render={(label) => <Item title={label} value={order?.code ?? "-"} />}
        />
        <SalifyFallback.Label
          path="Placed on:"
          default="Ngày tạo đơn"
          render={(label) => (
            <Item
              title={label}
              value={placedAt ? format(new Date(placedAt), "dd MM, yyyy HH:mm") : "-"}
            />
          )}
        />
        <SalifyFallback.Label
          path="Delivered on:"
          default="Ngày giao hàng"
          render={(label) => (
            <Item
              title={label}
              value={
                order?.orderDelivery?.expectedDeliveryTime
                  ? format(new Date(order.orderDelivery.expectedDeliveryTime), "dd MMM yyyy, HH:mm")
                  : order?.orderDelivery?.expectedOrderDeliveryNotes || "-"
              }
            />
          )}
        />
      </FlexBetween>

      {(order?.orderDetails ?? []).map(
        (
          {
            product,
            quantity,
            totalAmount: lineTotal,
            price,
          }: {
            product: Product;
            quantity: number;
            totalAmount?: number;
            price?: number;
          } = {
            product: {} as any,
            quantity: 0,
          },
          ind: number,
        ) => {
          const url = product?.slugName
            ? `${context?.config?.props?.prefixProductDetailURL ?? "product/"}${product?.slugName}`
            : "#";
          const unitPrice = price ?? product?.salePrice ?? 0;
          const lineAmount = lineTotal ?? unitPrice * quantity;

          return (
            <FlexBetween px={2} py={1} flexWrap="wrap" key={ind}>
              <FlexBox gap={2.5} alignItems="center">
                <Avatar
                  alt={product?.name}
                  src={toAssetImages(product?.imageUrl)}
                  sx={{
                    height: 64,
                    width: 64,
                  }}
                />

                <div>
                  <Link href={url}>
                    <H6>{product?.name}</H6>
                  </Link>
                  <Paragraph color="grey.600">
                    {formatMoney(unitPrice)} x {quantity}
                  </Paragraph>
                </div>
              </FlexBox>

              <H6>{formatMoney(lineAmount)}</H6>

              {/* <Paragraph color="grey.600" ellipsis>
                {product?.name}
              </Paragraph> */}

              {/* <Button
                variant="text"
                color="primary"
                href={
                  product?.slugName
                    ? `${
                        context?.config?.props?.prefixProductDetailURL ?? "product/"
                      }${product?.slugName}`
                    : "#"
                }
                LinkComponent={Link}
              >
                <SalifyFallback.Label path="View Product" default="Xem sản phẩm" />
              </Button> */}
            </FlexBetween>
          );
        },
      )}
    </Card>
  );
};

function Item({ title, value }: any) {
  return (
    <FlexBox gap={1} alignItems="center">
      <Paragraph color="grey.600">{title}</Paragraph>
      <Paragraph>{value}</Paragraph>
    </FlexBox>
  );
}

export default OrderedProducts;
